export var NUMBER_OF_WEEKS = 4;
